<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <div class="top-container">
                <div class="header-container">
                    <div class="header">
                        <div class="form-label">
                            {{ 'version.create.dialog.header.label' | translate }}
                        </div>
                        <div *ngIf="!isInFirstPage()" class="cancel-button" (click)="clearForm()">
                            {{ 'version.create.dialog.header.cancel' | translate }}
                        </div>
                    </div>
                    <div class="sub-header" data-cy="version-new-version-sub-header">
                        <ng-container *ngIf="isInFirstPage()">
                            {{ 'version.create.dialog.first-page.title' | translate }}
                        </ng-container>
                        <ng-container *ngIf="isInVersionReference()">
                            {{ 'version.create.dialog.reference.title' | translate }}
                        </ng-container>
                        <ng-container *ngIf="isInUpdates()">
                            {{ 'version.create.dialog.updates.title' | translate }}
                        </ng-container>
                        <ng-container *ngIf="isInTrialPage()">
                            {{ 'version.create.dialog.trial.title' | translate }}
                        </ng-container>
                        <ng-container *ngIf="isInVersionName()">
                            {{ 'version.create.dialog.name.title' | translate }}
                        </ng-container>
                    </div>
                </div>
                <div class="body-container">
                    <ng-container *ngIf="isInFirstPage()">
                        <ng-container *ngTemplateOutlet="firstPage"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="isInVersionReference()">
                        <app-version-reference-page
                            [versions]="versions"
                            [vessel]="data.vessel"
                            [referenceVersion]="referenceVersion"
                            (onOpenHistory)="openVersionHistory()"
                            (onReferenceSelected)="referenceSelected($event)"></app-version-reference-page>
                    </ng-container>
                    <ng-container *ngIf="isInUpdates()">
                        <app-updates-page
                            [isMajorUpdate]="isMajorUpdate"
                            (onOptionSelected)="isMajorUpdate = $event"></app-updates-page>
                    </ng-container>
                    <ng-container *ngIf="isInTrialPage()">
                        <app-trial-page
                            [isTrialRun]="isTrialRun"
                            (onOptionSelected)="isTrialRun = $event"></app-trial-page>
                    </ng-container>
                    <ng-container *ngIf="isInVersionName()">
                        <app-version-name-page
                            [isTrialRun]="isTrialRun"
                            [isMajorUpdate]="isMajorUpdate"
                            [referenceVersion]="referenceVersion"
                            [versions]="versions"
                            (onVersionNameChange)="versionName = $event"></app-version-name-page>
                    </ng-container>
                </div>
            </div>

            <div class="bottom-container">
                <div class="steps">
                    <ng-container *ngIf="!isInFirstPage()">
                        {{
                            'version.create.dialog.footer.step'
                                | translate
                                    : {
                                          step: getStepNumber(),
                                          total: totalSteps,
                                      }
                        }}
                    </ng-container>
                </div>
                <div class="buttons-container">
                    <div class="button" data-cy="version-new-version-back-button">
                        <div *ngIf="isInFirstPage()" (click)="clearForm()">
                            {{ 'version.create.dialog.footer.cancel' | translate }}
                        </div>
                        <div *ngIf="!isInFirstPage()" (click)="back()">
                            {{ 'version.create.dialog.footer.back' | translate }}
                        </div>
                    </div>
                    <div
                        class="button continue"
                        data-cy="version-new-version-continue-button"
                        [ngClass]="{
                            disabled: isStartDisabled() || isContinueDisabled(),
                        }"
                        (click)="continue()">
                        <ng-container *ngIf="isInFirstPage()">{{
                            'version.create.dialog.footer.start' | translate
                        }}</ng-container>

                        <ng-container *ngIf="isInVersionReference() || isInUpdates() || isInTrialPage()"
                            >{{ 'version.create.dialog.footer.continue' | translate }}
                        </ng-container>
                        <ng-container *ngIf="isInVersionName()">{{
                            'version.create.dialog.footer.confirm' | translate
                        }}</ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #firstPage>
    <div class="start-container">
        <div>{{ 'version.create.dialog.start.part1' | translate }}</div>
        <div>{{ 'version.create.dialog.start.part2' | translate }}</div>
        <div>{{ 'version.create.dialog.start.part3' | translate }}</div>
        <div>{{ 'version.create.dialog.start.part4' | translate }}</div>
    </div>
</ng-template>
